import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import FlagIcon from "@mui/icons-material/Flag";
import PushPinIcon from "@mui/icons-material/PushPin";
import { FormatToLocalSystemDateTime } from "./../../../../utils/dateFormat";
import { useState } from "react";
import "./SenderMessageCloud.css";
import Attachment from "./Attachment";
import ContextMenu from "./ContextMenu";
import { getOrgType } from "../../../../utils/Token";

const SenderMessageCloud = ({
  message,
  messageId,
  createdByName,
  createdByOrganizationType,
  createdOn,
  hasAttachment,
  attachmentId,
  attachmentName,
  attachmentSize,
  isPinned,
  isFlagged,
  onContextMenuSet,
  contextOptions,
  accessType,
  style
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMessageClick = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const handleContextClick = (option) => {
    setAnchorEl(null);
    onContextMenuSet(option);
  };
  return (
    <>
      <Box
        className="w-100 ms-auto"
        style={{ maxWidth: "calc(100% - 55px - 1rem)" }}
      >
        <Box className="w-100 mb-2 d-flex justify-content-between">
          <Box className="sender text-black">You</Box>
          <Box className="time">
            <Typography
              variant="body2"
              sx={{ color: "var(--profile-recent-active-time-clr)" }}
            >
              {isPinned && (
                <PushPinIcon
                  fontSize="1rem"
                  style={{ color: "var(--pin-icon-clr)" }}
                />
              )}
              {isFlagged && (
                <FlagIcon
                  fontSize="1rem"
                  style={{ color: "var(--flag-icon-clr)" }}
                />
              )}
              {FormatToLocalSystemDateTime(createdOn)}{" "}
              {/* {accessType === 1 && ( */}
              {(<>
                <span> for </span>{" "}
                {getOrgType() == "Admin" ?
                  <span className="to-show everyone">{accessType === 1 ? "All" : accessType === 2 ? "Vendor" : "Client"}</span>
                  : getOrgType() == "Vendor" ?
                    <span className="to-show everyone">{accessType === 1 ? "All" : accessType === 2 ? "Admin" : ""}</span>
                    : getOrgType() == "Client" ?
                      <span className="to-show everyone">{accessType === 1 ? "All" : accessType === 3 ? "Admin" : ""}</span>
                      : ""}
              </>
              )}
            </Typography>
          </Box>
        </Box>
        <Box
          onContextMenu={handleMessageClick}
          id={`box-message-${messageId}`}
          aria-controls={open ? `message-${messageId}` : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
        >
          {hasAttachment ? (
            <Attachment
              className={"attachment-sent"}
              attachmentSize={attachmentSize}
              attachmentName={attachmentName}
              message={message}
              createdOn={createdOn}
              attachmentId={attachmentId}
            />
          ) : (
            <Box className="msg-send p-3 mb-3" {...style}>{message}</Box>
          )}
        </Box>
        {
          <ContextMenu
            createdByName={createdByName}
            messageId={messageId}
            anchorEl={anchorEl}
            open={open}
            isPinned={isPinned}
            isFlagged={isFlagged}
            hasAttachment={hasAttachment}
            handleContextClick={handleContextClick}
            contextOptions={contextOptions}
          />
        }
      </Box>
    </>
  );
};

export default SenderMessageCloud;
